<script>
import VSelect from 'vuetify/es5/components/VSelect/VSelect'

export default {
    extends: VSelect,
    watch: {
        items(){
            this.defaultFirst();
        }
    },
    methods: {
        defaultFirst(){
            if(this.items.length == 1){
                this.selectItem(this.virtualizedItems[0]);
            }
        }
    },
    created(){
        this.defaultFirst();
    }
}
</script>